module.exports = __webpack_public_path__ + "static/media/plaque_or_2022.f9f66235.png";